function updateTime() {
    // Tokyo timezone
    const options = {
        timeZone: 'Asia/Tokyo',
        weekday: 'short', // e.g., Tue
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: true, // AM/PM format
    };

    const now = new Date();
    const formatter = new Intl.DateTimeFormat('en-US', options);
    const parts = formatter.formatToParts(now);

    // Extract parts
    const day = parts.find(p => p.type === 'weekday').value;
    const month = parts.find(p => p.type === 'month').value;
    const date = parts.find(p => p.type === 'day').value;
    const year = parts.find(p => p.type === 'year').value;
    const hour = parts.find(p => p.type === 'hour').value;
    const minute = parts.find(p => p.type === 'minute').value;
    const second = parts.find(p => p.type === 'second').value;
    const ampm = parts.find(p => p.type === 'dayPeriod').value.toUpperCase();

    // Format and display
    const formattedTime = `${day} / ${date}.${month}.${year}, ${hour}:${minute}:${second} ${ampm} TYO`;
    document.getElementById('timer').textContent = formattedTime;
}

// Update every second
setInterval(updateTime, 1000);
updateTime();